// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3aUXZ","productName":"Table_productName__1M_zE"};